import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UseQueryResult } from 'react-query';
import { match } from 'ts-pattern';
import BadgeBoolean from '../../../components/BadgeBoolean';
import TableHeader from '../../../components/Table/TableHeader';
import { BadgeStatus } from '../../../interfaces/badge';
import { TeacherListResponse } from '../../../interfaces/teachers';

interface DocentiTableProps {
  query: UseQueryResult<TeacherListResponse>;
}

const DocentiTable: React.FC<DocentiTableProps> = ({ query }) => {
  const navigate = useNavigate();
  const tableElements = [
    { key: null, label: 'Tessera' },
    { key: null, label: 'Cognome' },
    { key: null, label: 'Nome' },
    { key: null, label: 'Corso' },
    { key: null, label: 'Lezione' },
    { key: null, label: 'Sezione' },
    { key: null, label: 'Regione domicilio' },
    { key: null, label: 'Provincia domicilio' },
    { key: null, label: 'Tessera attiva' },
    { key: null, label: 'Mail' },
    { key: null, label: 'Telefono' },
  ];

  return (
    <div className='-my-2 overflow-x-auto'>
      <div className='inline-block min-w-full py-2 align-middle'>
        <div className='overflow-hidden ring-1 border ring-black ring-opacity-5 '>
          {match(query)
            .with({ status: 'success' }, (query) => {
              if (!query.data) {
                return (
                  <div className='text-gray-500 my-20 text-center'>
                    Non hai i permessi
                  </div>
                );
              }

              return (
                <table className='min-w-full divide-y divide-gray-300'>
                  <TableHeader columnsNames={tableElements} />
                  <tbody className='divide-y divide-gray-200 bg-white'>
                    {query.data.data.map((teacher) => (
                      <tr
                        key={teacher.id}
                        onClick={() => {
                          navigate(`/utenti/modifica/${teacher.attributes.profileId}`);
                        }}
                        className='hover:cursor-pointer hover:bg-neutral-100'
                      >
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-600'>
                          {teacher.attributes.badgeNumber}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.surname}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.name}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.course}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.lesson}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.section?.name}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.homeRegion?.name}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.homeProvince?.name}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          <BadgeBoolean
                            active={
                              teacher.attributes.badgeStatus === BadgeStatus.VALID
                            }
                          />
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.email}
                        </td>
                        <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                          {teacher.attributes.phone}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })
            .with({ status: 'idle' }, { status: 'loading' }, () => {
              return <p>Caricamento Docenti...</p>;
            })
            .with({ status: 'error' }, () => {
              return <p>Errore caricamento Docenti...</p>;
            })
            .exhaustive()}
        </div>
      </div>
    </div>
  );
};

export default DocentiTable;
